import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { disableAnalytics, enableAnalytics } from './analytics';

type ConsentCategory = 'necessary' | 'analytics' | 'marketing';

const COOKIE_NAME = 'jt_cookie_consent';

export const setupCookieConsent = (): void => {
  const syncConsent = (): void => {
    const consent = CookieConsent.getUserPreferences();
    const acceptedCategories = new Set<ConsentCategory>(consent.acceptedCategories as ConsentCategory[]);
    const hasAnalyticsConsent = acceptedCategories.has('analytics');
    const hasMarketingConsent = acceptedCategories.has('marketing');

    document.documentElement.dataset.cookieConsent = hasAnalyticsConsent || hasMarketingConsent
      ? 'all'
      : 'necessary';

    if (hasAnalyticsConsent || hasMarketingConsent) {
      void enableAnalytics();
    } else {
      disableAnalytics();
    }
  };

  disableAnalytics();

  CookieConsent.run({
    cookie: {
      name: COOKIE_NAME,
      sameSite: 'Lax',
    },
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: true,
      },
      marketing: {
        enabled: true,
      },
    },
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom center',
        equalWeightButtons: false,
        flipButtons: false,
      },
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description:
              'We use cookies to ensure the site works properly and to measure performance. You can accept all cookies or only those strictly necessary.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Necessary only',
            showPreferencesBtn: 'Manage preferences',
          },
          preferencesModal: {
            title: 'Cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Necessary only',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close',
            sections: [
              {
                title: 'Strictly necessary cookies',
                description:
                  'These cookies are required for the website to function and cannot be disabled.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Analytics cookies',
                description:
                  'These cookies help us understand how the site is used so we can improve it.',
                linkedCategory: 'analytics',
              },
              {
                title: 'Marketing cookies',
                description:
                  'These cookies are used to deliver relevant ads and measure their performance.',
                linkedCategory: 'marketing',
              },
            ],
          },
        },
      },
    },
    onConsent: syncConsent,
    onChange: syncConsent,
  });
};
